import { Box, Flex, FormControl } from '@chakra-ui/react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import FormLabel from '~/components/FormLabel/FormLabel';
import { RecentContentFiltersBarTagSelect } from '~/components/RecentContentFiltersBar/components';
import {
  datePickerControllerProps,
  datePickerProps,
} from '~/components/RecentContentFiltersBar/utils';
import Toggle from '~/components/Toggle';

import { DateRangePicker } from '../DateRangePicker';
import { Select } from '../Select';

const propTypes = {
  sortByValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onSortByChange: PropTypes.func.isRequired,
  sortingOptions: PropTypes.array,
  adFilterValue: PropTypes.bool,
  onAdFilterChange: PropTypes.func,
  tagsValue: PropTypes.arrayOf(PropTypes.string),
  onTagsChange: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onDatesChange: PropTypes.func.isRequired,
};
/* eslint-disable react/prop-types */
const SingleValue = ({ data, ...props }) => {
  const { label } = data;

  return (
    <components.SingleValue
      {...props}
    >{`Sort by ${label}`}</components.SingleValue>
  );
};
/* eslint-enable react/prop-types */

export const DesktopModalFiltersBar = ({
  sortByValue,
  onSortByChange,
  sortingOptions,
  adFilterValue,
  onAdFilterChange,
  tagsValue,
  onTagsChange,
  startDate,
  endDate,
  onDatesChange,
}) => {
  const handleToggle = () => {
    onAdFilterChange(!adFilterValue);
  };

  return (
    <Box backgroundColor="transparent" paddingY={2} width="100%">
      <Flex
        _last={{ marginBottom: '0' }}
        flexWrap="wrap"
        justifyContent="space-between"
        marginBottom={2}
      >
        <Flex flexWrap="wrap" width={{ base: '100%', sm: 'auto' }}>
          <Flex alignItems="center" flexBasis={{ base: 'auto', sm: '33%' }}>
            <DateRangePicker
              aria-label="Filter by date"
              startDate={startDate}
              endDate={endDate}
              onDatesChange={onDatesChange}
              controllerProps={{
                ...datePickerControllerProps,
                // so current month is on right
                initialVisibleMonth: () => dayjs().subtract(1, 'month'),
              }}
              // these are all spread into the button
              borderColor="primary.300"
              calendarIconProps={{
                marginRight: 0,
                marginLeft: 2,
                size: 4,
              }}
              fontSize="md"
              height="auto"
              marginBottom={2}
              marginRight={2}
              padding={2}
              {...datePickerProps}
            />
          </Flex>

          {onAdFilterChange && (
            <Flex alignItems="center">
              <FormControl
                alignItems="center"
                display="flex"
                justifyContent="center"
                marginBottom={2}
                width="auto"
              >
                <Toggle
                  id="ad-toggle-desktop"
                  isChecked={adFilterValue}
                  marginRight={2}
                  onChange={handleToggle}
                />
                <FormLabel
                  color="primary.400"
                  fontSize="md"
                  fontWeight="normal"
                  htmlFor="ad-toggle-desktop"
                  marginBottom={0}
                  paddingBottom={0}
                  verticalAlign="baseline"
                >
                  Includes #ad
                </FormLabel>
              </FormControl>
            </Flex>
          )}
        </Flex>
        <Flex
          alignItems="center"
          flexBasis={{ base: 'auto', sm: '33%' }}
          marginBottom={2}
          width={{ base: '100%', sm: 'auto' }}
        >
          <Box width={{ base: '100%', sm: '159' }}>
            <Select
              aria-label="Set order"
              components={{ SingleValue }}
              isSearchable={false}
              onChange={onSortByChange}
              options={sortingOptions}
              value={sortByValue}
            />
          </Box>
        </Flex>
      </Flex>
      {onTagsChange && (
        <RecentContentFiltersBarTagSelect
          inputProps={{
            sx: {
              ':placeholder-shown:not(:focus)': {
                backgroundColor: 'transparent',
                borderColor: 'primary.300',
              },
            },
          }}
          marginTop
          onChange={onTagsChange}
          tags={tagsValue}
        />
      )}
    </Box>
  );
};

DesktopModalFiltersBar.propTypes = propTypes;
